/**
 * Global Error Handler
 * Centralizes error processing and reporting.
 */

export const handleError = (error) => {
  // Extract relevant error information
  const errorInfo = {
    message: "Ocurrió un error inesperado",
    status: null,
    data: null,
    originalError: error,
  };

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    errorInfo.status = error.response.status;
    errorInfo.data = error.response.data;
    
    if (error.response.data && error.response.data.message) {
      errorInfo.message = error.response.data.message;
    } else if (error.response.status === 401) {
      errorInfo.message = "Sesión expirada. Por favor, inicia sesión de nuevo.";
    } else if (error.response.status === 403) {
      errorInfo.message = "No tienes permisos para realizar esta acción.";
    } else if (error.response.status === 404) {
      errorInfo.message = "Recurso no encontrado.";
    } else if (error.response.status >= 500) {
      errorInfo.message = "Error en el servidor. Intenta de nuevo más tarde.";
    }
  } else if (error.request) {
    // The request was made but no response was received
    errorInfo.message = "No se pudo conectar con el servidor. Verifica tu conexión.";
  } else {
    // Something happened in setting up the request that triggered an Error
    errorInfo.message = error.message;
  }

  // Log error for debugging (could be sent to an external service like Sentry)
  console.error("[GlobalErrorHandler]", errorInfo);

  return errorInfo;
};

/**
 * Utility to check if an error is a specific status.
 */
export const isStatus = (error, status) => {
  return error && error.status === status;
};
